export const DIRECTEUR_COMMERCIAL = 'DirecteurCommercial';
export const COMMERCIAL = 'Commercial';
export const ASSISTANT_COMMERCIAL = 'AssistantCommercial';
export const AUTRE = 'Autre';
export const ANCIEN_GESTIONNAIRE = 'AncienGestionnaire';
export const ANCIEN_ASSISTANT_COMMERCIAL = 'AncienAssistantCommercial';

export const LISTE_PROFIL = [
  { code: ANCIEN_ASSISTANT_COMMERCIAL, libelle: 'utilisateur.profil.ancienAssistantCommercial' },
  { code: ANCIEN_GESTIONNAIRE, libelle: 'utilisateur.profil.ancienGestionnaire' },
  { code: ASSISTANT_COMMERCIAL, libelle: 'utilisateur.profil.assistantCommercial' },
  { code: AUTRE, libelle: 'utilisateur.profil.autre' },
  { code: COMMERCIAL, libelle: 'utilisateur.profil.commercial' },
  { code: DIRECTEUR_COMMERCIAL, libelle: 'utilisateur.profil.directeurCommercial' },
];
